import { Card, CardContent } from "@/components/ui/card";
import { LeaderboardListItem } from "./LeaderboardListItem";
import { EmptyLeaderboardState } from "./EmptyLeaderboardState";

interface LeaderboardEntry {
  rank: number;
  name: string;
  amount: number;
}

interface LeaderboardSectionProps {
  leaderboard: LeaderboardEntry[];
  isLoading?: boolean;
  title?: string;
  maxEntries?: number;
  className?: string;
  testId?: string;
}

export function LeaderboardSection({ 
  leaderboard, 
  isLoading = false,
  title = "Top referrers this month",
  maxEntries = 2,
  className = "mt-6 lg:mt-8",
  testId = "card-leaderboard"
}: LeaderboardSectionProps) {
  const displayEntries = leaderboard.slice(0, maxEntries);

  return (
    <Card className={className} data-testid={testId}>
      <CardContent className="p-6">
        <div className="mb-6">
          <h3 className="text-xl font-bold text-gray-900 space-grotesk">{title}</h3>
        </div>
        <div className="space-y-4">
          {isLoading ? (
            <div className="space-y-4">
              {Array.from({ length: maxEntries }).map((_, index) => (
                <div key={index} className="animate-pulse">
                  <div className="grid grid-cols-4 gap-4 items-center py-3">
                    <div className="h-4 bg-gray-200 rounded w-8"></div>
                    <div className="flex items-center gap-3">
                      <div className="h-8 w-8 bg-gray-200 rounded-full"></div>
                      <div className="h-4 bg-gray-200 rounded w-24"></div>
                    </div>
                    <div className="h-4 bg-gray-200 rounded w-8"></div>
                    <div className="h-4 bg-gray-200 rounded w-8"></div>
                  </div>
                </div>
              ))}
            </div>
          ) : displayEntries.length > 0 ? (
            <>
              <div className="grid grid-cols-4 gap-4 text-sm font-medium text-gray-500 space-grotesk pb-2 border-b">
                <div>RANK</div>
                <div>NAME</div>
                <div>REWARDS EARNED</div>
              </div>
              {displayEntries.map((entry: LeaderboardEntry, index: number) => (
                <LeaderboardListItem key={entry.rank || index} entry={entry} index={index} />
              ))}
            </>
          ) : (
            <EmptyLeaderboardState />
          )}
        </div>
      </CardContent>
    </Card>
  );
}
